<script setup lang="ts">
import SupportOptions from './_components/SupportOptions.vue';
import SidebarPanel from '@components/layout/org&panel&support/SidebarPanel.vue';
import PanelLayoutContainer from '@components/layout/org&panel&support/PanelLayoutContainer.vue';
definePageMeta({
    layout: 'panel',
});
const siteConfigs = useSiteConfigs();
</script>

<template>
    <div class="panel-wrapper">
        <div
            class="panel-img"
            :style="{ '--panel': `url(${siteConfigs.panelBack})` }"
        />
        <PanelLayoutContainer no-padding>
            <div class="panel-content">
                <div class="sidebar-container">
                    <SidebarPanel />
                </div>
                <div class="main-container">
                    <nuxt-page />
                    <ClientOnly>
                        <SupportOptions />
                    </ClientOnly>
                </div>
            </div>
        </PanelLayoutContainer>
    </div>
</template>
<style scoped lang="scss">
.panel-content {
    display: flex;
    margin-top: -48px;
}
.sidebar-container {
    flex-shrink: 0;
    width: 25%;
    padding-left: 12px;
}
.main-container {
    flex: 1;
    padding-right: 12px;
    margin-top: 64px;
}
.panel-img {
    width: 100%;
    height: 270px;
    background-image: var(--panel);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
@media (max-width: $app-tablet-max-width) {
    .panel-wrapper {
        display: block;
    }

    .sidebar-container {
        width: 100%;
        max-width: none;
        padding: 0;
        display: none;
    }

    .panel-content {
        flex-direction: column;
        margin-top: 12px;
    }

    .main-container {
        padding: 0;
        margin-top: 8px;
    }
}

@media (max-width: $app-mobile-max-width) {
    .panel-content {
        margin-top: 0;
    }

    .panel-img {
        display: none;
    }
}
</style>
